import i18n from '../../../i18n';

const createOption = (value: string) => ({ value, label: i18n.t(value, { ns: 'languages' }) });
const languages = ['en', 'de', 'fr', 'es', 'it', 'nl'];

export const languageCodeOptions = languages.map(createOption);
